<script lang="ts">
	import { goto } from '$app/navigation';
	import enzian from "@enzianweb/shared/images/enzian_small.png";
	import { ClientView, DarkLightSwitch, getCookie, Icon, IconButton, login, setCookie } from '@enzianweb/shared';
	import { _ } from 'svelte-i18n';
	import { PARTNER_ROUTE } from '../partner/PartnerStore.svelte';
	import Navigation from './navigationitem.svelte';
	import NavigationMenu from './NavigationMenu.svelte';
	import Profile from './Profile.svelte';
	import RecommendModal from './RecommendModal.svelte';

	let isAuthenticated = $derived($login != null);
	let recommendWiggle = $derived(getCookie('recommended').length == 0);

	let showRecommendModal: boolean = $state(false);
	let prodColors = import.meta.env.MODE == 'production' || import.meta.env.MODE == 'demo';

	function navigateToHome() {
		goto('/');
	}
</script>

<header
	class="w-full shadow border-b-2 border-transparent bg-white dark:bg-dark-100 dark:border-dark-400 z-30"
	style="height: 60px;"
>
	<div
		style="height: 9px;"
		class="w-full bg-gradient-to-r {prodColors
			? 'from-secondary-100 to-secondary-300'
			: 'from-yellow to-orange'}"
	></div>
	<div
		style="width: 16px; height: 16px"
		class="absolute top-0 right-0 {prodColors ? 'bg-secondary-300' : 'bg-orange'}"
	></div>
	<svg style="width: 16px; right: 8px; top: 9px;" class="absolute">
		<circle cx="8px" cy="8px" r="8px" class="fill-white dark:fill-dark-100" />
	</svg>
	<div
		style="width: 8px; height: 36px;"
		class="absolute top-0 right-0 {prodColors ? 'bg-secondary-300' : 'bg-orange'}"
	></div>
	<svg style="width: 8px; top: 36px;" class="absolute right-0">
		<circle cx="8px" cy="0px" r="8px" class={prodColors ? 'fill-secondary-300' : 'fill-orange '} />
	</svg>

	<button
		id="burger-menu"
		class="p-4"
		onclick={() => {
			const navGrid = document.getElementById('nav-grid');

			if (navGrid?.classList.contains('active')) {
				navGrid?.classList.remove('active');
			} else {
				navGrid?.classList.add('active');
			}
		}}
	>
		<Icon name="bars" classInfo="dark:fill-secondary-500"></Icon>
	</button>

	<div id="nav-grid" class="header-grid gap-4 pr-8" style="margin-top: 4px;">
		<button onclick={navigateToHome}>
			<img style="height: 35px;" class="logo" src={enzian} alt="log" />
		</button>

		{#if isAuthenticated && !$login?.jwt.onlyMobile}
			<ClientView />

			<Navigation name={$_('navigation.folders_and_documents')} link="/documents" icon="folder" />
			<Navigation
				name={$_('navigation.customers_and_partners')}
				link="/{PARTNER_ROUTE}"
				icon="address-book"
			/>
			<Navigation name={$_('navigation.catalogues')} link="/catalogues" icon="clipboard-list" />
			<Navigation name={$_('navigation.text_blocks')} link="/text-blocks" icon="pen-nib" />

			<Navigation name={$_('navigation.settings')} link="/settings" icon="gear" />

			<Navigation
				link=""
				name={$_('navigation.support')}
				externalLink="https://www.enzianplus.ch/schulung"
				icon="message-question"
			/>

			<!--System admin links-->
			{#if $login?.systemAdmin}
				<NavigationMenu iconName="info" name={$_('navigation.menu_company')}>
					<Navigation
						icon="industry"
						name={$_('navigation.companymanagement')}
						link="/firm-management"
					/>
					<Navigation
						icon="money-check-dollar-pen"
						name={$_('navigation.ordermanagement')}
						link="/order-management"
					/>
					<Navigation icon="info" name={$_('navigation.system_info')} link="/system-info" />
				</NavigationMenu>
			{/if}
		{:else}
			<Navigation name={$_('navigation.login')} link="/login" />
		{/if}

		<div class="grow"></div>

		<div class="flex">
			{#if isAuthenticated}
				{#if !$login?.jwt.onlyMobile}
					<IconButton
						onClick={() => {
							//Trigger the modal
							showRecommendModal = true;
							const monthDate = new Date();
							//Remember that the user already clicked on it.
							setCookie(
								'recommended',
								'yes',
								new Date(monthDate.setMonth(monthDate.getMonth() + 3))
							);
							//We have to trigger the reactivity
							recommendWiggle = false;
						}}
						wiggle={recommendWiggle}
						showCircle={false}
						iconName="gift"
						hoverText={$_('navigation.bt_recommend')}
					/>
				{/if}
				<DarkLightSwitch />

				<Profile />
			{/if}
		</div>
	</div>
</header>

{#if showRecommendModal}
	<RecommendModal onModalClose={() => (showRecommendModal = false)}></RecommendModal>
{/if}

<style lang="postcss">
	.header-grid :global {
		@apply flex flex-col items-start bg-white w-full dark:bg-dark-100;
	}

	#burger-menu {
		display: none;
	}

	@media (max-width: 780px) {
		#burger-menu {
			display: block;
		}

		.header-grid {
			position: absolute;
			top: 45px;
			left: 0px;
			z-index: 99;
			padding: 12px;
		}

		.header-grid:not(.active) {
			display: none;
		}
	}

	@media (min-width: 780px) {
		.header-grid {
			flex-direction: row;
			padding-left: 12px;
		}
	}
</style>
